export default "__VITE_ASSET__BwxoA0jr__"